var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-menu-visible top-menu-dark"},[_c('div',{staticClass:"app-title sub-title"},[_c('span',{staticClass:"app-title-text"},[_vm._v("Bookme")]),(_vm.title)?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }